export const name = 'triggersAndReactions' as const
export const ReactionCreatorFactorySymbol = Symbol('ReactionCreatorFactory')
export const ReactionsStateApiSymbol = Symbol('ReactionsStateApiSymbol')
export const ViewportIntersectionHandlerSymbol = Symbol('ViewportIntersectionHandlerSymbol')
export const triggersBreakpointValidatorSymbol = Symbol('triggersBreakpointValidatorSymbol')
